import {NgModule} from '@angular/core';
import {BrowserModule}  from '@angular/platform-browser';
import {HttpModule} from '@angular/http';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {MainComponent} from './components/main/main.component';
import {RecordComponent} from './components/record/record.component';
import {RecordItemComponent} from './components/record-item/record-item.component';
import {TdIssuesComponent} from './components/td-issues/td-issues.component';

@NgModule({
  imports: [
    BrowserModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    MainComponent,
    RecordComponent,
    RecordItemComponent,
    TdIssuesComponent
  ],
  bootstrap: [MainComponent]
})
export class AppModule {
}


// WEBPACK FOOTER //
// ./admin/src/app/app.module.ts